// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"5f92830b","834":"5f92830b"}[chunkId] + ".chunk.css";
};